export default {
  SEARCH_REQUEST: "clinics/SEARCH_REQUEST",
  SEARCH_SUCCESS: "clinics/SEARCH_SUCCESS",
  SEARCH_FAILURE: "clinics/SEARCH_FAILURE",
  UPDATE_ITEMS: "clinics/UPDATE_ITEMS"
};
